var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { withPaymentBotToken } from "./recaptcha";
import React, { useCallback, useEffect, useState } from "react";
import client from "../../http/client";
import { PaymentForm } from "../paymentForm";
import { useCreditPaymentContext } from "./CreditPaymentContext";
import { PaymentErrorNotice } from "./PaymentErrorNotice";
import { RadixLoading } from "../primitives/RadixLoading";
import { AVSCollectionDetails } from "../avsCollection";
import { useOrderIntent } from "../../providers";
export var CayanPaymentForm = function () {
    var _a;
    var _b = useCreditPaymentContext(), handleCreditOrderComplete = _b.handleCreditOrderComplete, paymentError = _b.paymentError, reportProcessorError = _b.reportProcessorError, tip = _b.tip, processorInfo = _b.processorInfo, billingInfo = _b.billingInfo, isGuestUser = _b.isGuestUser, hasAvsConfigs = _b.hasAvsConfigs, isAvsValid = _b.isAvsValid, markPaymentSubmitting = _b.markPaymentSubmitting, checkoutAddressId = _b.checkoutAddressId, checkoutUserId = _b.checkoutUserId, checkoutComment = _b.checkoutComment, isCurbsideOrder = _b.isCurbsideOrder, shouldSendSmsAlerts = _b.shouldSendSmsAlerts, hasMarketingOptIn = _b.hasMarketingOptIn, smsNumber = _b.smsNumber, signUpRewards = _b.signUpRewards;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), shouldSaveCard = _d[0], setShouldSaveCard = _d[1];
    var showSavePaymentOption = !isGuestUser;
    var _e = useState(false), avsRequiredMessageVisible = _e[0], setAvsRequiredMessageVisible = _e[1];
    var avsIncomplete = hasAvsConfigs && !isAvsValid;
    var paymentFormDisabled = loading || avsIncomplete;
    var currentAddress = useOrderIntent().currentAddress;
    var rewardsSignupPayload = signUpRewards ? { sign_up_rewards: true } : {};
    useEffect(function () {
        if (!avsIncomplete) {
            setAvsRequiredMessageVisible(false);
        }
    }, [avsIncomplete]);
    var handlePaymentFieldBlockedAttempt = useCallback(function (event) {
        if (!avsIncomplete) {
            return;
        }
        var target = event.target;
        if (target instanceof HTMLElement && target.closest(".radix-avs-collection-form")) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        setAvsRequiredMessageVisible(true);
        var addressField = document.getElementById("avsAddress");
        if (addressField) {
            addressField.focus();
        }
    }, [avsIncomplete]);
    var reportValidationError = function (message) {
        reportProcessorError("cayan", { Message: message });
    };
    var handleTokenError = function (data) {
        var message = "There was a problem processing your card.";
        switch (data === null || data === void 0 ? void 0 : data.reason) {
            case "cardnumber":
                message = "That card number looks invalid. Please check it and try again.";
                break;
            case "UNAUTHORIZED":
                message = "We could not authorize your card. Please try again.";
                break;
            default:
                message = "There was a problem processing your card. Please try again.";
                break;
        }
        reportProcessorError("cayan", { message: message });
        setLoading(false);
        markPaymentSubmitting(false);
    };
    var handleTokenSuccess = function (tokenData) {
        if (!(tokenData === null || tokenData === void 0 ? void 0 : tokenData.token)) {
            reportProcessorError("cayan", { message: "We could not process your payment. Please try again or use a different payment method." });
            setLoading(false);
            markPaymentSubmitting(false);
            return;
        }
        var shouldReleaseSubmitting = true;
        withPaymentBotToken(__assign({ should_save_card: shouldSaveCard, vaultToken: tokenData.token, tip_amount: tip, comment: checkoutComment, user_id: checkoutUserId, address_id: currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.id, is_curbside_order: isCurbsideOrder, should_send_sms_alerts: shouldSendSmsAlerts, sms_number: smsNumber, has_marketing_opt_in: hasMarketingOptIn }, rewardsSignupPayload)).then(function (paymentData) { return client.post("/order/cayan", paymentData); })
            .then(function (response) {
            shouldReleaseSubmitting = false;
            handleCreditOrderComplete(response.data.order);
        })
            .catch(function (error) {
            reportProcessorError("cayan", error);
        })
            .finally(function () {
            setLoading(false);
            if (shouldReleaseSubmitting) {
                markPaymentSubmitting(false);
            }
        });
    };
    var handlePaymentSubmit = function () {
        setLoading(true);
        markPaymentSubmitting(true);
        CayanCheckoutPlus.setWebApiKey(String(processorInfo.web_api_key));
        CayanCheckoutPlus.createPaymentToken({
            success: handleTokenSuccess,
            error: handleTokenError,
        });
    };
    return (React.createElement("div", { className: "radix-credit-payment-form radix-credit-payment-form--cayan", role: "region", "aria-label": "Card payment details" },
        React.createElement("div", { className: "radix-credit-payment-header" },
            React.createElement("h3", { className: "radix-credit-payment-title", tabIndex: -1, "data-card-details-heading": "true" }, "Card Details")),
        React.createElement(PaymentErrorNotice, { error: paymentError }),
        loading ? React.createElement(RadixLoading, { label: "Processing payment" }) : null,
        React.createElement("div", { style: { display: loading ? "none" : "block" } },
            avsRequiredMessageVisible ? (React.createElement("p", { className: "radix-error-message", role: "alert" }, "Billing details are required before entering payment information.")) : null,
            React.createElement("div", { onMouseDownCapture: handlePaymentFieldBlockedAttempt, onTouchStartCapture: handlePaymentFieldBlockedAttempt, onPointerDownCapture: handlePaymentFieldBlockedAttempt },
                React.createElement(PaymentForm, { id: "cayan_payment_form", disabled: paymentFormDisabled, fieldAttributes: {
                        cardholderName: {
                            placeholder: "Cardholder name *",
                            "data-cayan": "cardholder",
                            autoComplete: "cc-name",
                        },
                        cardNumber: {
                            placeholder: "Card number *",
                            "data-cayan": "cardnumber",
                            inputMode: "numeric",
                            autoComplete: "cc-number",
                        },
                        expirationMonth: {
                            placeholder: "Exp. Month (MM) *",
                            "data-cayan": "expirationmonth",
                            inputMode: "numeric",
                            autoComplete: "cc-exp-month",
                        },
                        expirationYear: {
                            placeholder: "Exp. Year (YYYY) *",
                            "data-cayan": "expirationyear",
                            inputMode: "numeric",
                            autoComplete: "cc-exp-year",
                        },
                        securityCode: {
                            placeholder: "Security code *",
                            "data-cayan": "cvv",
                            inputMode: "numeric",
                            autoComplete: "cc-csc",
                        },
                    }, savePaymentOption: false, onSubmit: handlePaymentSubmit },
                    React.createElement(AVSCollectionDetails, { onSubmit: function () { } }))),
            React.createElement("input", { type: "hidden", value: (_a = billingInfo.billingZipcode) !== null && _a !== void 0 ? _a : "", "data-cayan": "zipcode", readOnly: true }))));
};
